import * as React from 'react';
import { FormControl } from '@common/components/form-control';
import cx from 'classnames';

import { ClickAwayListener } from '../ClickAwayListener';

import './EditableInput.styles.scss';

export class EditableInput extends React.Component {
    static defaultProps = {
        defaultValue: '',
        withClickAway: true,
    };

    state = {
        value: this.props.defaultValue,
    };

    handleChange = (e) => {
        e.persist();

        const { onChange } = this.props;
        const { value } = e.target;

        this.setState((state) => ({ ...state, value }));

        if (onChange) {
            onChange({ value, e });
        }
    }

    handleSave = (e) => {
        if (e) {
            e.preventDefault();
        } 

        const { defaultValue, onSave } = this.props;

        onSave(this.state.value, { changed: this.state.value !== defaultValue });
    }

    render() {
        const { withClickAway, classes = {}, native } = this.props;
        const inputProps = {
            autoFocus: true,
            className: cx('EditableInput__input', classes.input),
            value: this.state.value,
            onChange: this.handleChange,
        };

        const content = (
            <form 
                className={withClickAway 
                    ? cx('EditableInput__inner-root', classes.innerRoot) 
                    : cx('EditableInput', classes.root)
                } 
                onSubmit={this.handleSave}
            >
                {native 
                    ? <input {...inputProps} />
                    : <FormControl {...inputProps} />
                }
            </form>
        );

        if (withClickAway) {
            return (
                <ClickAwayListener className={cx('EditableInput', classes.root)} onClickAway={this.handleSave}>
                    {content}
                </ClickAwayListener>
            );
        }

        return content;
    }
}